import React from 'react';
import { PhoneIcon, CheckIcon } from 'lucide-react';
import { services, extraServices, PHONE_DISPLAY, PHONE_HREF } from '../data/content';
export function Services() {
  return <section id="what-we-remove" className="w-full bg-forest-50 py-16 lg:py-24" data-id="element-356" data-mp="1du0w47khbs6r">
      <div className="mx-auto max-w-6xl px-5" data-id="element-357" data-mp="1dw5ajjg089la">
        <div className="max-w-2xl" data-id="element-358" data-mp="18vr0xwyr8rl5">
          <p className="font-display text-sm uppercase tracking-[0.2em] text-ember-600" data-id="element-359" data-mp="18uodjz0n579z">
            What we remove
          </p>
          <h2 className="mt-2 font-display text-3xl uppercase leading-tight text-forest-800 sm:text-4xl" data-id="element-360" data-mp="z54uas90nbel">
            If it fits in the trailer, it&apos;s gone
          </h2>
          <p className="mt-3 text-lg text-ink-700" data-id="element-361" data-mp="u3yxojc8j3zs">
            One couch or an entire property — residential and commercial, all across North County.
          </p>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-362" data-mp="l4tzxf8hzeoo">
          {services.map(({
          icon: Icon,
          label,
          body,
          items
        }) => <li key={label} className="flex h-full flex-col rounded-lg border border-forest-100 bg-white p-6" data-id="element-363" data-mp="36c7p66ki0mn4">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-800" data-id="element-364" data-mp="3b3zksviihik4">
                <Icon className="h-6 w-6 text-ember-500" aria-hidden="true" data-id="element-365" data-mp="2xd2sz6wet5e4" />
              </span>
              <h3 className="mt-5 font-display text-xl uppercase leading-tight text-forest-800" data-id="element-366" data-mp="32bnurarb7x4o">
                {label}
              </h3>
              <p className="mt-2 text-base leading-relaxed text-ink-700" data-id="element-367" data-mp="3pym9a2vvcuzy">{body}</p>
              <ul className="mt-4 space-y-1.5 border-t border-forest-100 pt-4" data-id="element-368" data-mp="3u193gag0is0b">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm text-ink-700" data-id="element-369" data-mp="3g20zz5ctgxqb">
                    <CheckIcon className="h-4 w-4 shrink-0 text-ember-600" aria-hidden="true" data-id="element-370" data-mp="3kzj2oe08qgpv" />
                    {item}
                  </li>)}
              </ul>
              <a href={PHONE_HREF} className="mt-auto flex items-center gap-2 pt-5 font-display text-base uppercase tracking-wide text-forest-800 transition-colors duration-150 ease-out hover:text-ember-600" data-id="element-371" data-mp="29mgx0dzojbkh">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-372" data-mp="1ljk296e6oxng" />
                Quote this job
              </a>
            </li>)}
        </ul>

        <ul className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-373" data-mp="1gpfskfdjabio">
          {extraServices.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-3 rounded-md border border-dashed border-forest-700/40 px-4 py-3.5" data-id="element-374" data-mp="16u4elz9y98bz">
              <Icon className="h-5 w-5 shrink-0 text-forest-700" aria-hidden="true" data-id="element-375" data-mp="11tqhvddstkt9" />
              <span className="text-sm font-semibold text-forest-800" data-id="element-376" data-mp="xty3ul5mymgi">{label}</span>
            </li>)}
        </ul>

        <p className="mt-8 text-base text-ink-700" data-id="element-377" data-mp="sv4y5ewlbzqw">
          Not sure if we take it? Just ask —{' '}
          <a href={PHONE_HREF} className="font-semibold text-forest-800 underline decoration-ember-500 decoration-2 underline-offset-4" data-id="element-378" data-mp="2s6fjp7o5akb4">
            {PHONE_DISPLAY}
          </a>
          . We&apos;ll tell you straight.
        </p>
      </div>
    </section>;
}